module.exports = __webpack_public_path__ + "img/oth6.c6aee650.png";